<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="电话拨号" :width="1000" :open="modalVisible" :maskClosable="true" @ok="handleClose"
        @cancel="handleClose" :footer="null" :closable="true">
        <a-spin :spinning="state.loading">
            <a-row :gutter="48" style="margin: 10px 0;">
                <a-col :span="6">连接状态</a-col>
                <a-col :span="6">摘挂机状</a-col>
                <a-col :span="6">录音状态</a-col>
            </a-row>
            <a-row :gutter="48" style="margin: 10px 0;">
                <a-col :span="6">
                    <a-tag v-if="$store.state.usbphone.wsClient && $store.state.usbphone.icm_flag == 1"
                        color="green">已连接</a-tag>
                    <a-tag v-else color="red">未连接</a-tag>
                </a-col>
                <a-col :span="6">
                    <a-tag v-if="$store.state.usbphone.p_status == 0" color="red">挂机</a-tag>
                    <a-tag v-if="$store.state.usbphone.p_status == 1" color="green" :icon="h(SoundOutlined)">摘机</a-tag>
                    <a-tag v-if="$store.state.usbphone.p_status == 2" color="blue">HOLD</a-tag>
                    <a-tag v-if="$store.state.usbphone.p_status == 3" color="green"
                        :icon="h(SoundOutlined)">耳机摘机</a-tag>
                </a-col>
                <a-col :span="6">
                    <a-tag v-if="$store.state.usbphone.r_status == 0" color="red">停止录音</a-tag>
                    <a-tag v-if="$store.state.usbphone.r_status == 1" color="green"
                        :icon="h(CloudUploadOutlined)">正在录音</a-tag>
                </a-col>
            </a-row>
            <a-card>
                <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                    <a-form-item label="公司名称">
                        {{ formState.full_name }}
                    </a-form-item>
                    <a-form-item label="电话号码">
                        <a-space>
                            <a-input v-model:value="formState.phone" placeholder="请输入电话号码" style="width: 200px;"
                                @keyup.enter="makePhoneCall" />
                            <a-popconfirm v-if="$store.state.usbphone.p_status == 0" :title="`确定立即拨号?`"
                                @confirm="makePhoneCall">
                                <a-button type="primary" :loading="state.callLoading" size="small"
                                    :icon="h(PhoneOutlined)">立即拨号</a-button>
                            </a-popconfirm>
                            <a-button type="primary" danger @click="makePhoneCallEnd" :loading="state.callLoading"
                                size="small" v-else>挂断</a-button>
                            <a-divider type="vertical" />
                            <a-button type="primary" danger size="small" :icon="h(MessageOutlined)" @click="sendmsg"
                                :loading="state.msgPreLoading">发送短信</a-button>
                            <a-divider type="vertical" />
                            <a-button type="primary" size="small" :icon="h(ContainerOutlined)"
                                v-if="formState.customer_id" @click="addworkorder">添加工单</a-button>
                        </a-space>
                    </a-form-item>
                    <a-divider>额外信息（选填）</a-divider>
                    <a-form-item label="操作原因" name="reason">
                        <a-textarea placeholder="请输入" v-model:value="formState.reason"
                            @change="storeBeizhu"></a-textarea>
                    </a-form-item>
                    <a-form-item label="本次操作总结" name="remark">
                        <a-textarea placeholder="请输入" v-model:value="formState.remark"
                            @change="storeBeizhu"></a-textarea>
                    </a-form-item>
                    <div v-if="state.showMsg">
                        <a-form-item label="短信模板" name="templet"
                            title="默认标签：{#tel#}短信收到的号码，{#compayname#}公司名称，{#name#}法人代表姓名">
                            <a-textarea placeholder="默认标签：{#tel#}短信收到的号码，{#compayname#}公司名称，{#name#}法人代表姓名"
                                v-model:value="formState.templet" @change="updateMsg"></a-textarea>
                            <p v-if="state.showTemplet">
                                <a-row v-for="(value, index) in state.templets" :key="index">
                                    <a-col :span="2">{{ index + 1 }}</a-col>
                                    <a-col :span="22">
                                        <a @click="changeTemplet">{{ value }}</a>
                                    </a-col>
                                </a-row>
                            </p>
                            <a @click="showOrHideTemplet">获取短信模板</a>
                        </a-form-item>
                        <a-form-item label="短信内容" name="msg">
                            <p>{{ formState.msg }}</p>
                            <a-button type="primary" danger size="small" :icon="h(MessageOutlined)" @click="makeSendMsg"
                                :loading="state.msgLoading">立即发送短信</a-button>
                        </a-form-item>
                    </div>
                    <a-form-item label="操作">
                        <a-button type="primary" @click="submitForm" :loading="state.saveLoading"
                            :icon="h(SaveOutlined)">保存理由及总结</a-button>
                    </a-form-item>
                </a-form>
            </a-card>
        </a-spin>
        <!-- 添加工单 -->
        <create-work-order v-if="state.workOrderVisible" :counterfeitInfo="state.workOrderCustData"
            @cancel="handleCancel" @ok="handleOk" />
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, onBeforeUnmount, h, watch, computed } from 'vue'
import { PhoneOutlined, SaveOutlined, SoundOutlined, CloudUploadOutlined, MessageOutlined, ContainerOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
import { useStore } from 'vuex'
import createWorkOrder from '../../views/workOrder/CreateWorkOrder.vue'
const $store = useStore()
const ruleForm = ref()
const rules = {}
const formLayout = {
    labelCol: { xs: { span: 7 }, sm: { span: 7 } },
    wrapperCol: { xs: { span: 10 }, sm: { span: 10 } }
}

const modalVisible = computed({
    get: () => $store.state.usbphone.modalVisible,
    set: (val) => {
        if (!val) {
            $store.dispatch('usbphone/HidePhoneModal')
        }
    }
})

interface state {
    loading: boolean
    callLoading: boolean
    saveLoading: boolean
    showMsg: boolean
    msgPreLoading: boolean
    showTemplet: boolean
    thdata: any[],
    templets: any[],
    msgLoading: boolean
    isHangUpProcessing: boolean
    workOrderVisible: boolean
    workOrderCustData: any
}
const state = reactive<state>({
    loading: false,
    callLoading: false,
    saveLoading: false,
    showMsg: false,
    msgPreLoading: false,
    showTemplet: false,
    thdata: [],
    templets: [],
    msgLoading: false,
    isHangUpProcessing: false,
    workOrderVisible: false,
    workOrderCustData: {}
})
interface formState {
    phone: string
    customer_id: number
    full_name: string
    zipid: number | null
    reason: string
    remark: string
    templet: string
    msg: string
}
let formState = reactive<formState>({
    phone: '',
    customer_id: 0,
    full_name: '',
    zipid: null,
    reason: '',
    remark: '',
    templet: '',
    msg: ''
})

// ========== 新增：标志是否正在关闭弹窗 ==========
let isModalClosing = false

// 建立WebSocket连接（仅当锁可用时才会真正连接）
const connectWebSocket = () => {
    const ws = $store.state.usbphone.wsClient
    const isConnected = ws && ws.readyState === WebSocket.OPEN

    if (!isConnected) {
        console.log('建立WebSocket连接...')
        $store.dispatch('usbphone/Connect')
    } else {
        console.log('WebSocket已连接，无需重复连接')
    }
}

// 监听弹窗显示状态
watch(modalVisible, (newVal) => {
    if (newVal) {
        console.log('弹窗打开，准备连接WebSocket')
        // 重置关闭标志
        isModalClosing = false
        setTimeout(() => {
            connectWebSocket()
        }, 100)
        let modalCurentInfo = $store.state.usbphone.modalCurentInfo
        formState.customer_id = modalCurentInfo.customer_id
        formState.full_name = modalCurentInfo.full_name
        formState.phone = modalCurentInfo.phone
        formState.zipid = modalCurentInfo.zipid
        formState.reason = modalCurentInfo.reason
        formState.remark = modalCurentInfo.remark
    }
})

// 监听挂机状态变化
watch(() => $store.state.usbphone.p_status, (newVal) => {
    if (newVal === 0) {
        formState.zipid = null
        state.showMsg = false
        state.isHangUpProcessing = false
    }
})

onMounted(() => {
    console.log('组件挂载，modalVisible:', modalVisible.value)
    if (modalVisible.value) {
        setTimeout(() => {
            connectWebSocket()
        }, 200)
    }
    let modalCurentInfo = $store.state.usbphone.modalCurentInfo
    formState.customer_id = modalCurentInfo.customer_id
    formState.full_name = modalCurentInfo.full_name
    formState.phone = modalCurentInfo.phone
    formState.zipid = modalCurentInfo.zipid
    formState.reason = modalCurentInfo.reason
    formState.remark = modalCurentInfo.remark
})

// ========== 修改：组件卸载时由store统一管理 ==========
onBeforeUnmount(() => {
    console.log('组件即将卸载')

    // ========== 方案1 + 方案4 组合 ==========
    // 如果是用户主动关闭且正在通话，保持WS连接
    if (isModalClosing) {
        console.log('用户主动关闭弹窗且正在通话/录音，保持WS连接')
        // 延迟重置标志
        setTimeout(() => {
            isModalClosing = false
        }, 2000)
        return
    }

    // 延迟检查，由store的Disconnect统一判断
    setTimeout(() => {
        const pStatus = $store.state.usbphone.p_status
        const isRecording = $store.state.usbphone.r_status === 1
        const isInCall = $store.state.usbphone.isInCall
        const isHangUping = $store.state.usbphone.isHangUping
        const isUploading = $store.state.usbphone.uploadingRecord

        // 只要有任何一个标志为true，说明还在通话/录音/上传中，保持WS连接
        if (isInCall || isRecording || isHangUping || isUploading) {
            console.log('通话/录音/上传进行中，保持WS连接', {
                isInCall,
                isRecording,
                isHangUping,
                isUploading
            })
            return
        }

        // 只有在完全空闲时才断开，由store的Disconnect做最终判断
        if (pStatus === 0 && !isRecording) {
            console.log('无通话且无录音，准备断开WebSocket')
            $store.dispatch('usbphone/Disconnect')
        }
    }, 500)
})

// ========== 修改：关闭弹窗逻辑 ==========
const handleClose = () => {
    console.log('关闭弹窗')

    const pStatus = $store.state.usbphone.p_status
    const isInCall = $store.state.usbphone.isInCall
    const isRecording = $store.state.usbphone.r_status === 1
    const isHangUping = $store.state.usbphone.isHangUping
    const isUploading = $store.state.usbphone.uploadingRecord

    // 如果有任何通话/录音/上传标志，标记为"正在关闭弹窗"
    if (isInCall || isRecording || isHangUping || isUploading || pStatus !== 0) {
        isModalClosing = true
        console.log('通话/录音/上传进行中，仅隐藏弹窗，保留WS')
        $store.dispatch('usbphone/HidePhoneModal')
        message.info('电话仍在通话/录音中，可通过再次打开窗口恢复')

        // 延迟重置标志
        setTimeout(() => {
            isModalClosing = false
        }, 2000)
        return
    }

    // 完全空闲，直接断开
    console.log('无通话，关闭并断开WS')
    $store.dispatch('usbphone/Disconnect')
    $store.dispatch('usbphone/HidePhoneModal')
}

// ========== 修改：强制关闭弹窗 ==========
const safeCloseModal = () => {
    const pStatus = $store.state.usbphone.p_status
    const isInCall = $store.state.usbphone.isInCall
    const isRecording = $store.state.usbphone.r_status === 1

    if (pStatus === 0 && !isInCall && !isRecording) {
        $store.dispatch('usbphone/Disconnect')
        $store.dispatch('usbphone/HidePhoneModal')
        return true
    } else {
        console.log('强制关闭弹窗，但电话仍在通话/录音中')
        isModalClosing = true
        $store.dispatch('usbphone/HidePhoneModal')
        setTimeout(() => {
            isModalClosing = false
        }, 2000)
        return true
    }
}

defineExpose({
    safeCloseModal,
    showModal: () => {
        isModalClosing = false
        $store.dispatch('usbphone/ShowPhoneModal')
    },
    connectWebSocket
})

const makePhoneCall = () => {
    state.showMsg = false
    if (!formState.phone || formState.phone.length != 11) {
        message.error('未找到正确的手机号')
        return
    }
    // 拨号前确保ws已连接（若锁被占用，Connect会给出提示）
    if (!$store.state.usbphone.wsClient) {
        connectWebSocket()
    }
    state.callLoading = true
    let requestParam = {
        url: '/admin/v1/usbphoneCall',
        method: 'post',
        data: {
            'step': 1,
            'customer_id': formState.customer_id,
            'phone': formState.phone
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            formState.zipid = res.data
            let modalCurentInfo = $store.state.usbphone.modalCurentInfo
            modalCurentInfo.zipid = res.data
            $store.commit('usbphone/SET_MODALCURENTINFO', modalCurentInfo)
            $store.dispatch('usbphone/PhoneCall', { 'phone': formState.phone, 'zipid': res.data })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.callLoading = false
        })
}

const makePhoneCallEnd = () => {
    if (state.isHangUpProcessing) {
        message.warn("正在挂断中，请勿重复操作");
        return
    }
    state.isHangUpProcessing = true
    $store.dispatch('usbphone/PhoneCallEnd')
    message.loading('正在挂断并上传录音文件...', 1.5)

    setTimeout(() => {
        state.isHangUpProcessing = false
        if ($store.state.usbphone.p_status === 0) {
            message.success('通话已结束，录音已上传')
        }
    }, 3000)
}

const storeBeizhu = () => {
    let modalCurentInfo = $store.state.usbphone.modalCurentInfo
    modalCurentInfo.reason = formState.reason
    modalCurentInfo.remark = formState.remark
    $store.commit('usbphone/SET_MODALCURENTINFO', modalCurentInfo)
}

const submitForm = () => {
    if (!formState.customer_id) {
        return
    }
    if (!formState.zipid) {
        message.error('请先拨号')
        return
    }
    if (formState.remark == '' || formState.reason == '') {
        message.error('请输入本次拨号原因或总结')
        return
    }
    state.callLoading = true
    let requestParam = {
        url: '/admin/v1/usbphoneCall',
        method: 'post',
        data: {
            'step': 2,
            'zipid': formState.zipid,
            'customer_id': formState.customer_id,
            'phone': formState.phone,
            'remark': formState.remark,
            'reason': formState.reason
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            $store.dispatch('usbphone/AddPhoneModal', {
                phone: '',
                customer_id: null,
                full_name: ''
            })
            message.success('提交成功')
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.callLoading = false
        })
}

const sendmsg = () => {
    if (state.showMsg) {
        state.showMsg = false
        return
    }
    state.msgPreLoading = true
    let requestParam = {
        url: '/admin/v1/usbphone/smsThdata',
        method: 'post',
        data: {
            'customer_id': formState.customer_id,
            'phone': formState.phone
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            state.thdata = res.data.thdata
            state.templets = res.data.templets
            formState.templet = res.data.defTemp
            state.showMsg = true
            updateMsg()
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.msgPreLoading = false
        })
}

const updateMsg = () => {
    formState.msg = formState.templet.replace(/{#(\w+)#}/g, (match, key) => {
        return state.thdata[key] || match;
    });
}

const showOrHideTemplet = () => {
    state.showTemplet = !state.showTemplet
}

const changeTemplet = (templet: any) => {
    formState.templet = templet
    updateMsg()
    state.showTemplet = false
}

const makeSendMsg = () => {
    if (!formState.phone || formState.phone.length != 11) {
        message.error('未找到正确的手机号')
        return
    }
    if (!formState.msg) {
        message.error('请输入短信内容')
        return
    }
    state.msgLoading = true
    let requestParam = {
        url: '/admin/v1/usbphone/usbphoneSms',
        method: 'post',
        data: {
            'phone': formState.phone,
            'msg': formState.msg,
            'templet': formState.templet,
            'customer_id': formState.customer_id
        }
    }
    baseService(requestParam)
        .then((res: any) => {
            $store.dispatch('usbphone/SendMsg', { 'phone': formState.phone, 'msg': formState.msg })
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
            state.msgLoading = false
        })
}
//添加工单
const addworkorder = () => {
    if (!formState.customer_id) {
        message.error('只能添加对应主体的工单')
        return
    }
    let requestParam = {
        url: '/admin/v1/customerList',
        method: 'post',
        data: Object.assign({ page: 1, limit: 1, breakAdmin: 1 }, { customer_id: formState.customer_id })
    }
    baseService(requestParam)
        .then((res: any) => {
            if (res.data.list.length > 0) {
                let custData = res.data.list[0]
                state.workOrderCustData = {
                    customer_id: formState.customer_id,
                    full_name: formState.full_name,
                    upload_path: custData.upload_path,
                    seller_id: custData.seller_id,
                    platform_id: custData.platform_id
                }
                state.workOrderVisible = true
            } else {
                message.error('未查询到客户信息')
            }
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('操作失败,请联系管理员')
            }
        })
        .finally(() => {
        })
}
const handleCancel = () => {
    state.workOrderVisible = false
}
const handleOk = () => {
    state.workOrderVisible = false
}
</script>
